import React, { useState, useEffect } from 'react'
import Button, { TYPES } from '../Button/index'
import { getTruncatedText } from './utils'

/**
 * @param {Object} props - The props
 * @param {String} props.text - The content info text
 * @param {JSX.Element} props.children - The info content
 * @param {String} props.moreButtonLabel - The more button label
 * @param {Boolean} props.defaultExpanded - Whether the info is default expanded
 * @returns {JSX.Element} DetailPageV3Info
 */

const DetailPageV3Info = (props) => {
  const {
    text,
    children,
    moreButtonLabel,
    defaultExpanded = false,
  } = props

  const [moreInfoVisible, setMoreInfoVisible] = useState(defaultExpanded)

  useEffect(() => {
    setMoreInfoVisible(defaultExpanded)
  }, [defaultExpanded])

  return (
    <div className="detail-page-v3__info">
      {moreInfoVisible
        ? <div className="detail-page-v3__info-content">
          {children}
        </div>
        : <p className="detail-page-v3__info-text">
          {getTruncatedText(text)}
          <Button
            className="detail-page-v3__more-info-button detail-page-v3__more-info-button--desktop"
            type={TYPES.LINK}
            onClick={() => setMoreInfoVisible(true)}
          >
            {moreButtonLabel}
          </Button>
        </p>
      }
    </div>
  )
}

export default DetailPageV3Info
